/** Window event name to start the hands-on desktop tour (see InteractiveDesktopTour). */
export const INTERACTIVE_TOUR_START_EVENT = 'ace-interactive-tour-start';

export function requestInteractiveDesktopTour() {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(INTERACTIVE_TOUR_START_EVENT));
}

const progressListeners = new Set();

/** Subscribe to form / navigation progress while the interactive tour is running. */
export function subscribeInteractiveTourProgress(fn) {
  progressListeners.add(fn);
  return () => progressListeners.delete(fn);
}

export function emitInteractiveTourProgress(payload) {
  progressListeners.forEach((fn) => {
    try {
      fn(payload);
    } catch (e) {
      /* eslint-disable no-console */
      console.error('Interactive tour listener error', e);
    }
  });
}
